/**
 * Created by Qingger Corp.
 * User: tanjianzhen
 * Date: 2018-7-5
 * Time: 17:47
 * Desc:
 */
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
Component.registerHooks([]);

@Component
export default class SwiperCp extends Vue {
  @Prop({
    default: () => {
      return [];
    },
  })
    pictureList: ItemArray<ComponentsInfo>;

  @Prop({ default: '' }) father: string;
  @Prop({ default: '1' }) showType: string;
  @Prop({ default: 0 }) chooseIndex: number;
  @Prop({ default: true }) allowTouchMove: boolean;

  /**
   * 图片
   * @type {any[]}
   */
  public imageList: ItemArray<ComponentsInfo> = [];

  public mySwiper1: Swiper = {} as any;

  public showSiteName = '';

  public created() {
    this.imageList = this.pictureList;
  }

  public mounted() {
    this.mySwiper1 = new Swiper('.swiper-container2', {
      initialSlide: 0,
      /* loop: true,
            speed: 300, */
      setWrapperSize: false,
      autoHeight: true,
      reverseDirection: true,
      observer: true,
      observeParents: true,
      allowTouchMove: this.allowTouchMove,
      debugger: true,
      pagination: {
        el: '.swiper-pagination2',
      },
      updateOnImagesReady: true,
      autoplay: {
        disableOnInteraction: false,
      },
    });
  }

  /* 监听数据 */

  // 轮播
  @Watch('pictureList', { deep: true })
  watchPictureList(val) {
    this.imageList = val;
    const self = this;
    if (Array.isArray(self.mySwiper1)) {
      self.mySwiper1.forEach((element) => {
        element.destroy(true, true);
      });
    } else {
      self.mySwiper1.destroy(true, true);
    }
    self.imageList = val;
    self.mySwiper1 = new Swiper('.swiper-container2', {
      initialSlide: 0,
      /* loop: true,
             speed: 300, */
      setWrapperSize: false,
      autoHeight: true,
      reverseDirection: true,
      observer: true,
      observeParents: true,
      allowTouchMove: this.allowTouchMove,
      debugger: true,
      pagination: {
        el: '.swiper-pagination2',
      },
      updateOnImagesReady: true,
      autoplay: {
        disableOnInteraction: false,
      },
      /* onSlideChangeEnd: function(swiper){
                 swiper.update();
             } */
    });
  }
}
